import React, { useEffect, useState } from "react";
import EmploymentGapsForm from "./EmploymentGapsForm";
import { hasOnlySpaces } from "../../Helper/common";

const EmploymentGapFormContainer = (props) => {
  const {
    key,
    index,
    gapDetails,
    gapType,
    handleReason,
    hasError,
    sequence
  } = props;

  // const handleSubmit = (e) => {
  //   e.preventDefault();
  //   let hasError = false;
  //   let errData = [...errorData];
  //   for (var i in gap) {
  //     if (gap[i].gap_reason == "" || gap[i].gap_reason == null) {
  //       errData[i] = true;
  //       hasError = true;
  //     }
  //   }
  //   setErrorData(errData);
  //   if (!hasError) {
  //     // handleGapReasonSubmit(gap);
  //   }
  // };
  // const len = gapData.responseArr[`${gapReasonKey}`].length;
  // const gapKey = len == 1 ? "Gap" : "Gaps";

  // useEffect(() => {
  //   console.log("gap...", gap);
  //   console.log("error...", errorData);
  // });

  return (
    <div>
      {/* <h4 className="fnt-smi-bld auth-header mt-2">
        {len} {gapName} {gapKey} Found
      </h4> */}
      {/* <p class="text-muted">Please give appropriate reason</p> */}
        <EmploymentGapsForm
          key={key}
          sequence={sequence}
          data={gapDetails}
          index={index}
          gapType={gapType}
          handleReason={handleReason}
          hasError={hasError}
          gapName={""}
        />
    </div>
  );
};

export default EmploymentGapFormContainer;
